<template>
    <div class=" bg-round bg-fff">
        <!-- <div class="container">
            <header id="header">
                <div class="flex f-around">
                    <div class="header-li" @click="toPage('/competition/short')">短片奖（Short Film Award）</div>
                    <div class="header-li" @click="toPage('/competition/scenario')">剧本大赛（Script）</div>
                    <div class="header-li header-active" @click="toPage('/plan/media')">创作扶持（Creation）</div>
                    <div class="header-li" @click="toPage('/competition/winner')">获奖作品（Winners）</div>
                    <div class="header-li" @click="toPage('/merge/Activity')">展映活动（Exhibition）</div>
                </div>
            </header>
        </div> -->
        <div class="container">
            <Bread class="ma-t-30"/>
        </div>

        
        <div class="container line-height-35 main-md vhtml" id="app">
            <div v-html="Content"></div>
        </div>


        <div  class="img-a-bg" v-if="detail.Content">
            <img src="../../img/merge/i2.png" alt="" srcset="" class="img-logo c-pointer">
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";
    .header-li {
        margin-right: 40px;
    }
    .img-person {
        width: 220px;
    }
    @media (max-width:768px) {
        .img-a-bg{
            display:none;
        }
    }


    @media (max-width:768px) {
        .header-li {
            margin-right: 20px;
        }
        
    }
    @media (min-width:768px) {
        .main-md{
            padding-left: 181px;
            padding-right: 210px;
        }
    }

    .img-a-bg {
        width: 100%;
        height: 285px;
        background: url('../../img/merge/cr1.png') no-repeat;
        background-size: cover;
        background-position: center center;
        text-align: right;
        line-height: 285px;
    }

    .img-logo {
        width: 206px;
        height: 206px;
        margin-right: 40px;
    }

    .btn-next {
        width: 300px;
        height: 50px;
        line-height: 50px;
        color: #fff;
        border-radius: 10px;
        text-align: center;
        background-color: #FB004D;
        margin: 40px auto;
        cursor: pointer;
        display: block;
        text-decoration: none;
    }

    .btn {
        width: 100%;
    }

    .container .img {
        width: 120px;
        margin: 0 auto;
    }
</style>
<script>
    import {getOther} from "../../api.js";
    export default {
        name: "merge",
        data() {
            return {
                footbottom:123,
                Content:"",
                detail:"",
            };
        },
        created() {
           console.log("开始开发")
            this.getDetail();
        },
        
        methods: {
            //跳转链接
            toBanerHref() {
                let i = this.$refs.carousel.activeIndex;
                let item = this.bannerlist[i];
                console.log(item);
                if (!item.Href) {
                    return;
                } else {
                    location.href = item.Href;
                }
            },
            //获取数据
            getDetail() {
                let data = {
                    code: "creation.filmstar",
                };
                getOther(data).then((res) => {
                    console.log(res);
                    this.detail = res.data.Data;
                    this.Content=res.data.Data.Content;
                });
            },
            toPage(url){
                this.$router.push(url);
            }
        },
    };
</script>
